import { from, merge, Subject } from 'rxjs';
import { activePpwRecId$ } from '@/services/activePpwRecId$';
import { publishReplay, refCount, switchMap } from 'rxjs/operators';
import { getDepartmentColleagues } from './getDepartmentColleagues';

const refreshDepartmentColleagues$ = new Subject();
export const departmentColleagues$ = merge(activePpwRecId$, refreshDepartmentColleagues$).pipe(
  switchMap(() => from(getDepartmentColleagues())),
  publishReplay(1),
  refCount()
);
export const refreshDepartmentColleagues = () => refreshDepartmentColleagues$.next();
